export default "__VITE_ASSET__DwwgZFbV__"